<template>
  <div class="null flex-colum">
    <van-empty description="暂无数据" />
  </div>
</template>
<script>
export default {
  name: "NullState",

  data() {
    return {
      message: "我的消息我的消息我的消息",
    };
  },
};
</script>
<style lang="less" scoped>
.null {
  width: 100%;
  position: absolute;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  .imgsize {
    width: 250px;
    height: 250px;
  }
  color: #b9b9b9;
  font-size: 16px;
}
</style>
